import React, { Suspense, useEffect, useState } from "react";
import { Offline } from "react-detect-offline";
import { connect } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { routerHistory } from "..";
import {
  fetchOrganisationBranches,
  fetchOrganisationCategories,
  fetchOrganisationDetails,
} from "../api/organisation.api";
import { fetchUserDetails } from "../api/user.api";
import Callback from "../Auth/Callback";
import GoogleAuthVerified from "../Auth/GoogleAuthVerified";
import Signin from "../Auth/Signin";
import OrganisationLogin from "../Components/Application/NewOnboarding/Authentication/Login";
import { OpenVendorForm } from "../Components/Application/OpenVendor";
import { PageViewTracker } from "../Components/Common/Component/page-view-tracker";
import { OfflinePopup } from "../Components/OfflinePopup";
import { firebase_app } from "../Config/Config";
import { LoggerContext } from "../context/logging";
import Loader from "../Layout/Loader";
import LayoutRoutes from "../Route/LayoutRoutes";
import Dashboard from "../Components/Application/Dashboard";
import {
  authHeader,
  configureFakeBackend,
  handleResponse,
} from "../Services/fack.backend";
import { authRoutes } from "./AuthRoutes";
import PrivateRoute from "./PrivateRoute";
import { ProjectApi } from "../api";
import axios from "axios";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
// setup fake backend
configureFakeBackend();
const Routers = (props) => {
  const { dispatch } = props;
  const [currentUser, setCurrentUser] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const jwt_token = localStorage.getItem("token");
  const logger = React.useContext(LoggerContext);
  const [projects, setProjects] = useState([]);
  const [branches, setBranches] = useState([]);

  const setUserDataToRedux = () => {
    return fetchUserDetails().then((res) => {
      localStorage.setItem("currentUser", JSON.stringify(res));
      localStorage.setItem("authenticated", true);
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "user",
          value: res,
        },
      });

      // Identify the user in moengage
      logger.identify(res);
    });
  };
  const setOrganisationData = () => {
    return fetchOrganisationDetails().then((res) => {
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "organisation",
          value: res,
        },
      });
    });
  };

  const setOrganisationCategories = () => {
    return fetchOrganisationCategories().then((res) => {
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "categories",
          value: res,
        },
      });
    });
  };

  const fetchProjects = async (params = {}) => {
    return axios.get(`${ProjectApi}`, { params: { ...params } }).then((res) => {
      setProjects(res.data?.results);
      console.log("i-log> projects", res.data);
      return res.data;
    });
  };

  const setBranchData = () => {
    return fetchOrganisationBranches().then((res) => {
      if (!props?.settings?.branch?.id && res[0]) {
        dispatch({
          type: "settings/CHANGE_SETTING",
          payload: {
            setting: "branch",
            value: res[0],
          },
        });
      }
      if (props?.settings?.branch?.id) {
        const branchData = res?.find(
          (branch) => branch?.id === props?.settings?.branch?.id
        );

        if (branchData) {
          dispatch({
            type: "settings/CHANGE_SETTING",
            payload: {
              setting: "branch",
              value: branchData,
            },
          });
        }
      }

      return res;
    });
  };

  const setBranchFromProject = async () => {
    const projects = await fetchProjects();
    const branches = await fetchOrganisationBranches();
    const project = projects.find((p) => p?.id === props.settings?.project?.id);
    const branch = branches.find((branch) => branch?.id === project?.branch);
    console.log("i-log> selected branch current", branch, branches);
    if (project) {
      console.log("i-log> dispatch branch change");
      setTimeout(() => {
        props.dispatch({
          type: "settings/CHANGE_SETTING",
          payload: {
            setting: "branch",
            value: branch ?? branches[0],
          },
        });
      }, 1000);
    }
  };

  const setAllReduxData = async () => {
    await setUserDataToRedux();
    await setOrganisationData();
    await setOrganisationCategories();
    const branches = await setBranchData();
    const projects = await fetchProjects();
    // Set branch id from projects[0]'s branch
    if (projects[0]?.branch) {
      const branch = branches.find(
        (branch) => branch.id === projects[0].branch
      );
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "branch",
          value: branch,
        },
      });
    }
  };

  useEffect(() => {
    let abortController = new AbortController();
    const requestOptions = { method: "GET", headers: authHeader() };
    fetch("/users", requestOptions).then(handleResponse);
    firebase_app.auth().onAuthStateChanged(setCurrentUser);
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    setAllReduxData().then(() => {
      setBranchFromProject();
    });
    return () => {
      abortController.abort();
    };
  }, []);

  console.log(props, "porpos");
  return (
    // <Auth0Provider
    //   domain={auth0.domain}
    //   clientId={auth0.clientId}
    //   redirectUri={auth0.redirectUri}
    // >
    <BrowserRouter basename={"/"} history={routerHistory}>
      <>
        {/* <Offline>
          <OfflinePopup />
        </Offline> */}
        <PageViewTracker />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={"/"} element={<PrivateRoute />}>
              {currentUser !== null || authenticated || jwt_token ? (
                <>
                  <Route
                    exact
                    path={``}
                    element={<Navigate to={`/app/project/project-list`} />}
                  />
                  <Route
                    exact
                    path={`/`}
                    element={<Navigate to={`/app/project/project-list`} />}
                  />
                </>
              ) : (
                ""
              )}
              <Route path={`/*`} element={<LayoutRoutes />} />
            </Route>
            <Route
              path={`/open-vendor/:orgname/:id/:org`}
              element={<OpenVendorForm />}
            />
            <Route path={`/callback`} render={() => <Callback />} />
            <Route exact path={`/dashboard`} element={<Dashboard />} />
            <Route exact path={`/login`} element={<Signin />} />
            <Route
              exact
              path={`/google-auth-verified`}
              element={<GoogleAuthVerified />}
            />
            <Route
              exact
              path={`/organisation-onboarding`}
              element={<OrganisationLogin />}
            />
            {authRoutes.map(({ path, Component }, i) => (
              <Route
                path={path}
                element={Component}
                key={i}
                setAllReduxData={setAllReduxData}
              />
            ))}
          </Routes>
        </Suspense>
      </>
    </BrowserRouter>
    // </Auth0Provider>
  );
};

export default connect(mapStateToProps)(Routers);
